module.exports = __webpack_public_path__ + "img/XLA.7581e0a8.png";